import { BasicRequest } from "./BasicRequest";

export class MessageRequest extends BasicRequest{
    MessageId:string;
}